import { AfterViewInit, Directive, Injectable, Input, OnDestroy } from '@angular/core';
import {  MatTabGroup } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'rememberSelectedTabIndex, [rememberSelectedTabIndex]',
    standalone: false
})
export class RememberSelectedTabIndexDirective implements AfterViewInit, OnDestroy {
    /**
     * @default `component`
     * @`component`
     ** will make the settings to be shared for different url with different id.
     ** Example: `projects/detail/6491647e24063fe74355e153` and `projects/detail/64916480f2aca84ed4ebe533` will share the same stored tabIndex.
     *
     * @ `url`
     ** will make the settings unique for different url.
     ** Example: `projects/detail/6491647e24063fe74355e153` and `projects/detail/64916480f2aca84ed4ebe533` will have their own stored tabIndex.
     */
    @Input() rememberBy: 'url' | 'component' = 'component';

    tabIdentifier?: string;
    subscription?: Subscription;

    constructor(
        private host: MatTabGroup,
        private route: ActivatedRoute,
        private router: Router,
        private svc: RememberSelectedTabIndexService) {}

    ngAfterViewInit(): void {
        this.tabIdentifier = this.getTabIdentifier();
        this.host.selectedIndex = this.svc.selectedIndexMap[this.tabIdentifier];

        this.subscription = this.host.selectedIndexChange.subscribe(
            selectedIndex => this.svc.selectedIndexMap[this.tabIdentifier] = selectedIndex
        );
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    getTabIdentifier() {
        const tabTitles = this.host._allTabs.map(tab => tab.textLabel);
        const rememberByIdentifier = this.rememberBy === 'component' ?
            this.getPageComponentName() : this.getUrl();
        return `${rememberByIdentifier}__${tabTitles.join('#')}`;
    }

    private getPageComponentName() {
        return this.route.snapshot.component.name;
    }

    private getUrl() {
        return (this.router.url);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RememberSelectedTabIndexService {
    selectedIndexMap: {[tabIdentifier: string]: number} = {};
}
